/**
 * PrivacyContainer
 * --
 */
import React from 'react';
import PrivacyPresenter from './PrivacyPresenter';
import { useParams } from 'react-router-dom';
import { useGetProvisions } from 'hooks/ProvisionHooks';

const PrivacyContainer = (props) => {
  /* ===== ROUTE ===== */
  const { policyType } = useParams() ?? 'privacy';

  /* ===== PROPS ===== */
  /* ===== Data ===== */
  const { data: Provision } = useGetProvisions(null, {
    select: (res) => {
      const { status, data } = res;
      if (status !== 200) return [];

      return data;
    },
    initialData: [],
  });

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /**
   * 약관 데이터 정제
   * --
   */
  const ProvisionData = React.useMemo(() => {
    if (!Provision.length) return;

    const findData = Provision.find(
      (policy) => policy.provision_type === policyType.toLocaleUpperCase()
    );

    return findData;
  }, [policyType, Provision]);

  /* ===== RENDER ===== */
  return (
    <>
      <PrivacyPresenter data={ProvisionData} />
    </>
  );
};

export default PrivacyContainer;
